import i18n from 'i18n';
import { FieldError, FieldErrorsImpl } from 'react-hook-form';

const MIN_LENGTH_SM = 3;
const MIN_LENGTH = 8;

const EMAIL_REGEX = /^([a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;

function validateEmail(email: string): boolean {
    return EMAIL_REGEX.test(email);
}

function validateUrl(url: string): boolean {
    try {
        const parsedURL = new URL(url);
        return parsedURL.host !== '';
    } catch {
        return false;
    }
}

/**
 * Dict containing validator functions.
 * validators[key] s a function that returns a boolean
 * indicating wether the value passed is valid.
 * E.g. validators.email('aba') => false
 * validators.email(test@test.com) => true
 * validators.required('') => false
 * validators.required('djasfds') => true
 * @type {Object}
 */
const validators = {
    required: (value: string): string => value,
    isEmail: validateEmail,
    isUrl: validateUrl,
    minLengthSm: (value: string): boolean | string =>
        value && value.length >= MIN_LENGTH_SM,
    minLength: (value: string): boolean | string =>
        value && value.length >= MIN_LENGTH,
    match: (a: string, b: string): boolean => a === b,
};
export default validators;

export const getErrorMessage = (
    error?: FieldError | Merge<FieldError, FieldErrorsImpl> | undefined,
): string | null => {
    if (!error) return null;

    if (error.type === 'required') return i18n.t('validators.required');
    return error.message as string | null;
};
